import { InquiryStageEnum } from '@/gen/cortado/v1/settings_pb'
import type { Contact } from '@/gen/cortado/v1/contacts_pb'
import type { Lead } from './types'

// Helper to create timestamp from milliseconds
const createTimestamp = (ms: number) => {
  const seconds = Math.floor(ms / 1000)
  return {
    seconds: BigInt(seconds),
    nanos: 0
  } as any
}

export const mockLeads: Lead[] = [
  {
    id: '1',
    organizationId: 'org-1',
    contactId: 'contact-1',
    stage: InquiryStageEnum.INQUIRY_STAGE_NEW,
    status: InquiryStageEnum.INQUIRY_STAGE_NEW,
    eventType: 'Party',
    firstEventDate: createTimestamp(new Date('2025-11-09T13:00:00').getTime()),
    eventsCount: 1,
    totalGuestCount: 50,
    createdAt: createTimestamp(Date.now() - 5 * 60 * 60 * 1000),
    createdBy: 'system',
    updatedBy: 'system',
    contact: {
      id: 'contact-1',
      organizationId: 'org-1',
      firstName: 'Brittney',
      lastName: 'Zillig',
      email: 'john.smith@techcorp.com',
      phoneNumber: '+1 (555) 123-4567',
      createdBy: 'system',
      updatedBy: 'system',
    } as Contact,
    company: 'TechCorp Inc.',
    quoteTotal: 1250,
  },
  {
    id: '2',
    organizationId: 'org-1',
    contactId: 'contact-2',
    stage: InquiryStageEnum.INQUIRY_STAGE_IN_PROGRESS,
    status: InquiryStageEnum.INQUIRY_STAGE_IN_PROGRESS,
    eventType: 'Wedding',
    firstEventDate: createTimestamp(new Date('2025-12-15T18:00:00').getTime()),
    eventsCount: 1,
    totalGuestCount: 150,
    eventLocation: 'Grand Hotel Ballroom',
    createdAt: createTimestamp(Date.now() - 10 * 24 * 60 * 60 * 1000),
    createdBy: 'system',
    updatedBy: 'system',
    contact: {
      id: 'contact-2',
      organizationId: 'org-1',
      firstName: 'Sarah',
      lastName: 'Johnson',
      email: 'sarah.j@startupxyz.com',
      phoneNumber: '+1 (555) 234-5678',
      createdBy: 'system',
      updatedBy: 'system',
    } as Contact,
    company: 'StartupXYZ',
    quoteTotal: 8500,
  },
  {
    id: '3',
    organizationId: 'org-1',
    contactId: 'contact-3',
    stage: InquiryStageEnum.INQUIRY_STAGE_QUOTE_SENT,
    status: InquiryStageEnum.INQUIRY_STAGE_QUOTE_SENT,
    eventType: 'Corporate',
    firstEventDate: createTimestamp(new Date('2026-01-20T14:00:00').getTime()),
    eventsCount: 2,
    totalGuestCount: 200,
    eventDays: 2,
    eventLocation: 'Conference Center',
    createdAt: createTimestamp(Date.now() - 15 * 24 * 60 * 60 * 1000),
    createdBy: 'system',
    updatedBy: 'system',
    contact: {
      id: 'contact-3',
      organizationId: 'org-1',
      firstName: 'Mike',
      lastName: 'Davis',
      email: 'mike.davis@email.com',
      phoneNumber: '+1 (555) 987-6543',
      createdBy: 'system',
      updatedBy: 'system',
    } as Contact,
    quoteTotal: 4750,
  },
  {
    id: '4',
    organizationId: 'org-1',
    contactId: 'contact-4',
    stage: InquiryStageEnum.INQUIRY_STAGE_ACCEPTED,
    status: InquiryStageEnum.INQUIRY_STAGE_ACCEPTED,
    eventType: 'Wedding',
    firstEventDate: createTimestamp(new Date('2025-10-12T16:00:00').getTime()),
    eventsCount: 1,
    totalGuestCount: 175,
    eventLocation: 'Seaside Resort',
    createdAt: createTimestamp(Date.now() - 20 * 24 * 60 * 60 * 1000),
    createdBy: 'system',
    updatedBy: 'system',
    contact: {
      id: 'contact-4',
      organizationId: 'org-1',
      firstName: 'Emily',
      lastName: 'Chen',
      email: 'emily.chen@globalsolutions.com',
      phoneNumber: '+1 (555) 876-5432',
      createdBy: 'system',
      updatedBy: 'system',
    } as Contact,
    company: 'Global Solutions Ltd.',
    quoteTotal: 12500,
  },
  {
    id: '5',
    organizationId: 'org-1',
    contactId: 'contact-5',
    stage: InquiryStageEnum.INQUIRY_STAGE_ACCEPTED,
    status: InquiryStageEnum.INQUIRY_STAGE_ACCEPTED,
    eventType: 'Corporate',
    firstEventDate: createTimestamp(new Date('2026-02-28T10:00:00').getTime()),
    eventsCount: 1,
    totalGuestCount: 100,
    eventLocation: 'Downtown Convention Center',
    createdAt: createTimestamp(Date.now() - 25 * 24 * 60 * 60 * 1000),
    createdBy: 'system',
    updatedBy: 'system',
    contact: {
      id: 'contact-5',
      organizationId: 'org-1',
      firstName: 'David',
      lastName: 'Wilson',
      email: 'david.wilson@enterprise.com',
      phoneNumber: '+1 (555) 456-7890',
      createdBy: 'system',
      updatedBy: 'system',
    } as Contact,
    company: 'Enterprise Co.',
    quoteTotal: 6200,
  },
  {
    id: '6',
    organizationId: 'org-1',
    contactId: 'contact-6',
    stage: InquiryStageEnum.INQUIRY_STAGE_REJECTED,
    status: InquiryStageEnum.INQUIRY_STAGE_REJECTED,
    eventType: 'Party',
    firstEventDate: createTimestamp(new Date('2025-08-15T19:00:00').getTime()),
    eventsCount: 1,
    totalGuestCount: 0,
    eventLocation: 'Private Residence',
    createdAt: createTimestamp(Date.now() - 30 * 24 * 60 * 60 * 1000),
    createdBy: 'system',
    updatedBy: 'system',
    contact: {
      id: 'contact-6',
      organizationId: 'org-1',
      firstName: 'Lisa',
      lastName: 'Brown',
      email: 'lisa.brown@email.com',
      createdBy: 'system',
      updatedBy: 'system',
    } as Contact,
    quoteTotal: 850,
  },
]
